import React from "react";
import autoBind from "react-autobind";

import { Row, Col } from "react-bootstrap";

import GridFilterBase from "./grid.filter.base";

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props, {
      contains: { title: "Contém:", type: "text", operation: "contains" },
      startsWith: { title: "Começa com:", type: "text", operation: "startsWith" }
    });
    autoBind(this);
  }

  getDefaultInputValues(column) {
    return {
      isNotCase: false,
      isNot: false,
      value: "",
      advancedSearchOperator: "or",
      advancedSearchValues: [],
      isNullable: !!column.isNullable,
      onlyEmpty: column.checkSomenteNull
    };
  }

  updateIcon(column) {
    let filterColumns = column.inputs.filter(
      x => x.value || x.value === 0 || (x.advancedSearchValues && x.advancedSearchValues.length != 0) || x.onlyEmpty
    );
    column.isFiltered = filterColumns && filterColumns.length != 0;
  }

  handleJustNull(e) {
    let { column } = this.props;
    this.onlyEmpty = e.target.checked;

    column.inputs.forEach(x => {
      x.onlyEmpty = this.onlyEmpty;
      x.value = this.onlyEmpty ? ' ' : '';
    });
    this.updateContextColumn(column);
  }

  handleChangeValue(index, field, prop) {
    let { column } = this.props;
    return e => {
      column.inputs[index][field] = e.target[prop || "value"];
      this.updateContextColumn(column);
    };
  }

  handleIsNot(e) {
    let { column } = this.props;
    let isNot = e.target.checked;
    column.inputs.forEach(x => (x.isNot = isNot));
    this.updateContextColumn(column);
  }

  addAdvancedSearch(index, ignoreEmpty) {
    let { column } = this.props;
    return e => {
      let input = column.inputs[index];
      let value = input.value ? input.value.trim() : input.value;
      if (!value) {
        if (!ignoreEmpty) {
          _alert.warning("Digite um termo a ser pesquisado.");
          input.value = "";
        }
        return;
      }
      let splitValues = value.split(";");
      input.advancedSearchValues = [...input.advancedSearchValues, ...splitValues];
      input.value = "";
      this.updateContextColumn(column);
    };
  }

  onSubmit() {
    let { column } = this.props;
    if (column.isAdvancedSearch) {
      let contains = column.inputs[0];
      if (contains) {
        this.addAdvancedSearch(0, true)();
      }

      let startsWith = column.inputs[1];
      if (startsWith) {
        this.addAdvancedSearch(1, true)();
      }
    }
  }

  removeAdvancedSearch(indexInput, index) {
    let { column } = this.props;
    return e => {
      let inputItem = column.inputs[indexInput];
      inputItem.advancedSearchValues.splice(index, 1);
      this.updateContextColumn(column);
    };
  }

  changeAdvancedSearch() {
    let { column } = this.props;
    column.isAdvancedSearch = !column.isAdvancedSearch;
    this.updateContextColumn(column);
  }

  render() {
    const { column } = this.props;
    const { isAdvancedSearch, inputs } = column;

    if (!inputs) return null;

    let checked = inputs.length > 0 ? inputs[0].onlyEmpty : column.checkSomenteNull;

    return (
      <ul>
        {inputs.map(this.renderInput)}
        <div className="filterColunm mt-2">
          <label className="checkbox">
            <input className="mt-0" type="checkbox" checked={(inputs[0] || {}).isNot || false} onChange={this.handleIsNot} /> Registros não
            coincidentes
          </label>
        </div>
        {column.isNullable && (
          <div className="filterColunm mt-2">
            <label className="checkbox">
              <input
                className="handleJustNull"
                type="checkbox"
                onChange={this.handleJustNull}
                checked={checked}
              />
              Somente Vazio
            </label>
          </div>
        )}
        <p className="advanced-search" onClick={this.changeAdvancedSearch}>
          <span>{isAdvancedSearch ? "Retornar para a busca simples" : "Busca avançada"}</span>
        </p>
      </ul>
    );
  }

  renderInput(input, index) {
    const { column, hash } = this.props;
    const { isAdvancedSearch } = column;
    return (
      <li className="filterLine" key={index}>
        <div className="filterColunm">
          <label htmlFor="input">{input.title}</label>
          <Row>
            <Col lg={isAdvancedSearch ? 8 : 12}>
              <input 
                name={hash} 
                type="text" 
                className="form-control" 
                value={input.value} 
                onChange={this.handleChangeValue(index, "value")}
                disabled={input.onlyEmpty} 
              />
            </Col>
            {isAdvancedSearch && (
              <Col lg={1}>
                <button type="button" className="btn btn-primary btn-custom" onClick={this.addAdvancedSearch(index)}>
                  <i className="fa fa-plus" />
                </button>
              </Col>
            )}
            {isAdvancedSearch && (
              <Col lg={3}>
                <select
                  className="form-control"
                  value={input.advancedSearchOperator}
                  onChange={this.handleChangeValue(index, "advancedSearchOperator")}
                >
                  <option value="or">Ou</option>
                  <option value="and">E</option>
                </select>
              </Col>
            )}
          </Row>
          {isAdvancedSearch && (
            <Row>
              <Col lg={12}>
                <label className="advanced-search-label">Termos pesquisados</label>
                <ul className="advanced-search-list">
                  {input.advancedSearchValues == 0 && <li className="empty-message">Não há termos a serem pesquisados.</li>}
                  {input.advancedSearchValues.map((item, i) => (
                    <li key={i}>
                      <i className="fa fa-times-circle" title={"Remover da Busca Avançada"} onClick={this.removeAdvancedSearch(index, i)} />{" "}
                      <span title={item}>{item}</span>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          )}
        </div>
      </li>
    );
  }
}

export default GridFilter;
